import React, { useState, useEffect } from 'react';
import { Table, Button, Space, Modal, Form, Input, message, Card } from 'antd';
import api from '@/services/api'; // Assuming you have a configured API service

const ManagementWorkingHours = () => {
    const [workingHours, setWorkingHours] = useState([]);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [editData, setEditData] = useState(null);

    const [deleteId, setDeleteId] = useState(null);
    const [loadingDelete, setLoadingDelete] = useState(false);

    const [loading, setLoading] = useState(false);
    const [loadingCreate, setLoadingCreate] = useState(false);

    useEffect(() => {
        fetchWorkingHours();
    }, []);

    const fetchWorkingHours = async () => {
        setLoading(true);
        try {
            const response = await api()({
                url: '/webshop/management/working-hours',
            });
            setWorkingHours(response.data.data);
        } catch (error) {
            message.error('Error fetching working hours');
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = () => {
        setIsModalVisible(true);
        setEditData(null);
    };

    const handleDelete = async (id) => {
        setDeleteId(id);
        setLoadingDelete(true);
        try {
            await api()({
                method: 'DELETE',
                url: `/webshop/management/working-hours/${id}`,
            });
            message.success('Working hour deleted successfully');
            setWorkingHours(workingHours.filter(item => item.Id !== id));
        } catch (error) {
            message.error('Error deleting working hour');
        } finally {
            setDeleteId(null);
            setLoadingDelete(false);
        }
    };

    const handleSubmit = async (values) => {
        setLoadingCreate(true);
        try {
            if (editData) {
                // Update existing working hour
                await api()({
                    method: 'PUT',
                    url: `/webshop/management/working-hours/${editData.Id}`,
                    data: values,
                });
                message.success('Working hour updated successfully');
            } else {
                // Create new working hour
                await api()({
                    method: 'POST',
                    url: '/webshop/management/working-hours',
                    data: values,
                });
                message.success('Working hour created successfully');
            }
            setIsModalVisible(false);
        } catch (error) {
            message.error('Error submitting form');
        } finally {
            setLoadingCreate(false);
            fetchWorkingHours(); // Refresh the list after create/update
        }
    };

    const columns = [
        {
            title: 'Text',
            dataIndex: 'Title',
            key: 'title',
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button
                        loading={loadingDelete && deleteId === record.Id}
                        danger 
                        onClick={() => handleDelete(record.Id)}
                    >
                        Delete
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <Card>
            <Button type="primary" onClick={handleAdd} style={{ marginBottom: 16 }}>
                Add New Working Hour
            </Button>
            <Table
                columns={columns}
                dataSource={workingHours}
                rowKey="Id"
                loading={loading}
            />

            {/* Modal for adding/editing working hours */}
            <Modal
                title={editData ? 'Edit Working Hour' : 'Add New Working Hour'}
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
            >
                <Form
                    initialValues={editData}
                    onFinish={handleSubmit}
                    layout="vertical"
                >
                    <Form.Item
                        name="Title"
                        label="Title"
                        rules={[{ required: true, message: 'Please input the title!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name="Time"
                        label="Time"
                        rules={[{ required: true, message: 'Please input the time!' }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item>
                        <Button loading={loadingCreate} type="primary" htmlType="submit">
                            {editData ? 'Update' : 'Submit'}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </Card>
    );
};

export default ManagementWorkingHours;
